import React from 'react'
import { Box } from '@mui/material'
import { useGetTreeById } from '../../../reducers/trees_hooks'
import { useAtomValue, useSetAtom } from 'infrastructure/state/jotai.wrapper'
import { Table } from 'shared/ui/Table/Table'
import {
  incorrectCountTitleAtom,
  requiresUpdateListAtom,
  treeAtom,
  updatingAtom,
} from './atoms'
import { useTableColumns, useUpdateAllItems } from './utility'
import { ConfirmCommitButton } from 'shared/ui'
import { NodeListFixes } from './NodeListFixes'

export function ContentNumbering({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const { tree } = useGetTreeById({ treeId, versionId })
  useSetAtom(treeAtom)(tree)

  if (!tree) {
    return (
      <Box>
        <Box>Content Numbering</Box>
        <Box>Retrieving Tree</Box>
      </Box>
    )
  }

  return (
    <Box>
      <Box>
        <strong>Content Numbering</strong>
      </Box>
      <Box padding="10px">{tree.title}</Box>
      <NodeListFixes />
      <ContentTable />
    </Box>
  )
}

function ContentTable() {
  const columns = useTableColumns()
  const needsUpdate = useAtomValue(requiresUpdateListAtom)
  const updating = useAtomValue(updatingAtom)
  const updateAll = useUpdateAllItems()
  const title = useAtomValue(incorrectCountTitleAtom)

  return (
    <Table
      title={title}
      toolBarItems={[
        <ConfirmCommitButton
          key="UpdateAll"
          disabled={updating || !needsUpdate.length}
          onClick={updateAll}
        >
          Update All
        </ConfirmCommitButton>,
      ]}
      columns={columns}
      items={needsUpdate}
    />
  )
}
